import GrayButton from 'ui/GrayButton/GrayButton';
import DiscordIcon from 'ui/SVG/DiscordIcon';
import InstagramIcon from 'ui/SVG/InstagramIcon';
import TelegramIcon from 'ui/SVG/TelegramIcon';
import TwitterIcon from 'ui/SVG/TwitterIcon';
import Text from 'ui/Text/Text';
import Title from 'ui/Title/Title';
import SocialTItle from './SocialTItle';
import './Social.scss';
import './SocialAnim.scss';

const Social: React.FC = () => {
  return (
    <div className="social section" id="social">
      <SocialTItle />
      <div className="container social__container">
        <div className="social__content">
          <Title className="social__title">Join our community</Title>
          <div className="social__socials">
            <nav className="social__socials-nav">
              <a href="/#" target="_blank" className="social__link">
                <TelegramIcon />
              </a>
              <a
                href="https://discord.gg/6yfNwDpkwP"
                target="_blank"
                className="social__link"
              >
                <DiscordIcon />
              </a>
              <a
                href="https://twitter.com/samudaixyz"
                target="_blank"
                className="social__link"
              >
                <TwitterIcon />
              </a>
              <a href="/#" target="_blank" className="social__link">
                <InstagramIcon />
              </a>
            </nav>
          </div>
          <Text className="social__text">
            Catalysts of blockchain evolution, driven by innovation and
            dedicated to shaping a decentralized future
          </Text>
        </div>
        {/* <GrayButton className="start-btn social__btn">
          <div className="start-btn__img">
            <img src={require('images/sphere-journey.png')} alt="icon" />
          </div>
          <span className="start-btn__text">Start Now</span>
        </GrayButton> */}
      </div>
    </div>
  );
};

export default Social;
